export default "__VITE_ASSET__CKd5q7jW__"